import { useState } from "react";
import { useTranslation } from "react-i18next";
import { GetAllBillingEntityDto } from "@/types/api/api-types";
import { DisplayTypeSelectBo } from "./invoices/displayTypeSelectBo";
import { InvoiceTable } from "../invoices/invoicesTab/invoiceTable";
import { InvoiceToBeValidatedTable } from "../invoices/invoicesToBeValidatedTab/invoiceToBeValidatedTable";
import { LitigeTable } from "../invoices/litigesTab/litigeTable";
import { DisplayType } from "@/types/invoiceDisplayTypes";
import { BlockedInvoiceTable } from "../invoices/blockedTab/bockedInvoiceTable";
import { SelectV2 } from "@/components/ui/customs/select-v2";

type InvoicesProps = {
  companyId: string;
  billingEntities?: GetAllBillingEntityDto;
};

export const Invoices = ({ companyId, billingEntities }: InvoicesProps) => {
  const { t } = useTranslation("boClients");
  const [selectedBillingEntity, setSelectedBillingEntity] = useState<string | null>(null);
  const [displayType, setDisplayType] = useState<DisplayType>("invoice");

  return (
    <div className="flex w-full flex-1 flex-col gap-8">
      <DisplayTypeSelectBo
        setDisplayType={setDisplayType}
        displayType={displayType}
        counter={false}
      />
      {displayType === "invoice" ? (
        <>
          <SelectV2
            options={
              billingEntities?.map((billingEntity) => ({
                value: billingEntity.id,
                label: billingEntity.deletedAt
                  ? t("clientInvoices.deletedBillingEntityOption", {
                      companyName: billingEntity.companyName,
                    })
                  : billingEntity.companyName,
              })) || []
            }
            onChange={(value) => setSelectedBillingEntity(value || null)}
            clearable={true}
            placeholder={t("clientInvoices.billingEntityFilterPlaceholder")}
            wrapperClassName="w-[300px]"
          />
          <InvoiceTable
            companyId={companyId}
            billingEntityId={selectedBillingEntity}
            initMonth={false}
          />
        </>
      ) : displayType === "litige" ? (
        <LitigeTable companyId={companyId} />
      ) : displayType === "invoiceBlocked" ? (
        <BlockedInvoiceTable companyId={companyId} />
      ) : (
        <InvoiceToBeValidatedTable companyId={companyId} />
      )}
    </div>
  );
};
